import React, { useEffect, useState } from 'react';
import {
    airlineImageFn,
    convertMinutesFn, differenceBetweenTwoDatesWithTime, formatDayWiseDateFn,
    formatPrice,
    getUserToken,
    formatTimeWithDayAndTimeFn,formatePriceFn
} from "../../../helper/commonFunction";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Mousewheel, FreeMode } from 'swiper/modules';
import "../../../assets/css/vender-swiper.css";
import {
    CabinIcon,
    CheckinIcon,
    ChevronDownIcon,
    ChevronUpIcon,
    CloseIcon,
    FlightIcon,
    FlightIconTop,
    FlightRequiredChangeIcon,
    FlightSeatIcon,
    LuggageIcon,
    MealIcon,
    SelectedFlightIcon,
    TicketIcon,
    TimeIcon
} from "../../../helper/HwIcon";
import CommonPopup from '../../common-popup/CommonPopup';
import { ApiCall } from '../../../helper/axios';

export const FareCheckIcon = () => (
    <svg width="15" height="15" viewBox="0 0 16 16" fill="none">
        <circle cx="8" cy="8" r="7.5" fill="#E6F9F0" stroke="#10B981" />
        <path d="M4.5 8.2L6.8 10.5L11.5 5.5" stroke="#10B981" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const FareMinusIcon = () => (
    <svg width="15" height="15" viewBox="0 0 16 16" fill="none">
        <circle cx="8" cy="8" r="7.5" fill="#FEF3C7" stroke="#F59E0B" />
        <path d="M5 8H11" stroke="#D97706" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
);

export const FareCrossIcon = () => (
    <svg width="15" height="15" viewBox="0 0 16 16" fill="none">
        <circle cx="8" cy="8" r="7.5" fill="#FEE2E2" stroke="#EF4444" />
        <path d="M5.5 5.5L10.5 10.5M10.5 5.5L5.5 10.5" stroke="#DC2626" strokeWidth="1.4" strokeLinecap="round" />
    </svg>
);

export const formatHeaderDate = (dateString) => {
    if (!dateString) return '';
    try {
        const d = new Date(dateString);
        if (isNaN(d.getTime())) return '';
        const weekday = d.toLocaleDateString('en-US', { weekday: 'short' });
        const day = d.getDate().toString().padStart(2, '0');
        const month = d.toLocaleDateString('en-US', { month: 'short' });
        const year = d.getFullYear().toString().slice(-2);
        return `${weekday}, ${day} ${month} ${year}`;
    } catch (e) {
        return '';
    }
};

export const formatHeaderDateWithSuffix = (dateString) => {
    if (!dateString) return '';
    try {
        const d = new Date(dateString);
        if (isNaN(d.getTime())) return '';
        const weekday = d.toLocaleDateString('en-US', { weekday: 'short' });
        const month = d.toLocaleDateString('en-US', { month: 'short' });
        const day = d.getDate();
        const year = d.getFullYear();

        const getSuffix = (n) => {
            if (n > 3 && n < 21) return 'th';
            switch (n % 10) {
                case 1:  return 'st';
                case 2:  return 'nd';
                case 3:  return 'rd';
                default: return 'th';
            }
        };

        return `${weekday}, ${month} ${day}${getSuffix(day)}, ${year}`;
    } catch (e) {
        return '';
    }
};

export const formatHeaderDateRange = (startDateString, endDateString) => {
    if (!startDateString) return '';
    if (!endDateString) return formatHeaderDateWithSuffix(startDateString);

    try {
        const d1 = new Date(startDateString);
        const d2 = new Date(endDateString);
        if (isNaN(d1.getTime())) return '';
        if (isNaN(d2.getTime())) return formatHeaderDateWithSuffix(startDateString);

        if (d1.toDateString() === d2.toDateString()) {
            return formatHeaderDateWithSuffix(startDateString);
        }

        const weekday1 = d1.toLocaleDateString('en-US', { weekday: 'short' });
        const month1 = d1.toLocaleDateString('en-US', { month: 'short' });
        const day1 = d1.getDate();
        const year1 = d1.getFullYear();

        const weekday2 = d2.toLocaleDateString('en-US', { weekday: 'short' });
        const month2 = d2.toLocaleDateString('en-US', { month: 'short' });
        const day2 = d2.getDate();
        const year2 = d2.getFullYear();

        const getSuffix = (n) => {
            if (n > 3 && n < 21) return 'th';
            switch (n % 10) {
                case 1:  return 'st';
                case 2:  return 'nd';
                case 3:  return 'rd';
                default: return 'th';
            }
        };

        if (year1 === year2) {
            return `${weekday1}, ${month1} ${day1}${getSuffix(day1)} - ${weekday2}, ${month2} ${day2}${getSuffix(day2)}, ${year1}`;
        }
        return `${weekday1}, ${month1} ${day1}${getSuffix(day1)}, ${year1} - ${weekday2}, ${month2} ${day2}${getSuffix(day2)}, ${year2}`;
    } catch (e) {
        return '';
    }
};

export const formatHeaderTime = (dateString) => {
    if (!dateString) return '';
    try {
        const d = new Date(dateString);
        if (isNaN(d.getTime())) return '';
        const hours = d.getHours().toString().padStart(2, '0');
        const minutes = d.getMinutes().toString().padStart(2, '0');
        return `${hours}:${minutes}`;
    } catch (e) {
        return '';
    }
};

export const getEffectiveTotalPriceFn = (pricingData) => {
    const delta = Number(pricingData?.totalPrice);
    const safeDelta = Number.isFinite(delta) ? delta : 0;
    if (!pricingData?.bundle) return safeDelta;
    const baseAmount = parseFloat(pricingData?.mainAmount);
    return Number.isFinite(baseAmount) ? baseAmount + safeDelta : safeDelta;
};


const FareViewsComponent = ({
    flights,
    flightBookingFn,
    agentActiveCurrency,
    selectedMultiflights,
    roundTripDomestic,
    selectMultiFlightFn,
    openFareViews,
    setOpenFareViews,
    queryParams,
    showBundles,
    setBundle,
    onSelectAirArabiaBundle,
    selectedAirArabiaBundle,
    displayPrice,
    totalMarkupAmount = 0,
    loadAlternateFlightFareData,
    showVendorLogo,
    isShowFlightAlternateOption

}) => {
    const lockBodyScroll = () => {
        if (typeof document === 'undefined') return;
        const body = document.body;
        const currentCount = Number(body.dataset.hwScrollLockCount || '0');
        if (currentCount === 0) {
            body.dataset.hwScrollLockOverflow = body.style.overflow || '';
            body.style.overflow = 'hidden';
        }
        body.dataset.hwScrollLockCount = String(currentCount + 1);
    };

    const unlockBodyScroll = () => {
        if (typeof document === 'undefined') return;
        const body = document.body;
        const currentCount = Number(body.dataset.hwScrollLockCount || '0');
        const nextCount = Math.max(0, currentCount - 1);
        body.dataset.hwScrollLockCount = String(nextCount);
        if (nextCount === 0) {
            body.style.overflow = body.dataset.hwScrollLockOverflow || '';
            delete body.dataset.hwScrollLockOverflow;
        }
    };

    const getNdcPricingWithoutMarkupFn = (pricingData = {}) => {
        const markupValue = Number(totalMarkupAmount) || 0;
        if (!markupValue) {
            return pricingData;
        }
        const currentTotalPrice = Number(pricingData?.totalPrice);
        if (!Number.isFinite(currentTotalPrice)) {
            return pricingData;
        }
        return {
            ...pricingData,
            totalPrice: Math.max(0, currentTotalPrice - markupValue),
        };
    };
    const [showFlightDetails, setShowFlightDetails] = useState(false);
    const [activeFlightOption, setActiveFlightOption] = useState({});
    const [showNDCPopup, setShowNDCPopup] = useState(false);
    const [selectedNDCFare, setSelectedNDCFare] = useState(null);
    const [selectedBundle, setSelectedBundle] = useState(null);
    const [bundleData, setBundleData] = useState(null);
    const [bundleLoading, setBundleLoading] = useState(false);
    const [alternateFareData, setAlternateFareData] = useState({});
    const [alternateFareLoading, setAlternateFareLoading] = useState({});
    const userToken = getUserToken()

    const [flightDetails, setFlightDetails] = useState({
        departureFlights: [],
        returnFlights: [],
        multiCityData: {},
    })

    useEffect(() => {
        if (!openFareViews) return undefined;
        lockBodyScroll();
        return () => {
            unlockBodyScroll();
        };
    }, [openFareViews]);

    useEffect(() => {
        if (flights?.segments?.length && flights?.tripType === 'COMBO') {
            if (Array.isArray(queryParams?.segments)) {
                let multiCityData = {};
                queryParams?.segments?.forEach((segment, segmentIndex) => {
                    const { fromAirport, toAirport, departDate } = segment;
                    let matchedFlights = [];
                    let collecting = false;
                    for (const flight of flights?.segments || []) {
                        const flightDepartureDate = flight?.departure?.departureTime?.split("T")[0];
                        if ((flight.departure.airportCode === fromAirport || flight?.neareastFromAirport === fromAirport) && flightDepartureDate === departDate) {
                            collecting = true;
                        }
                        if (collecting) {
                            matchedFlights.push(flight);
                            if (flight.arrival.airportCode === toAirport || flight?.neareastToAirport === toAirport) {
                                break;
                            }
                        }
                    }

                    if (matchedFlights.length) {
                        multiCityData[segmentIndex] = {
                            flights: matchedFlights,
                            source: flights?.source
                        };
                    }
                });
                setFlightDetails({
                    ...flightDetails,
                    multiCityData: multiCityData,
                });
            } else {
                const departureFlights = [];
                const returnFlights = [];
                let multiCityData = {};
                let isDeparture = true;
                for (const flight of flights?.segments) {
                    if (isDeparture) {
                        departureFlights.push(flight);
                        if (flight.arrival.airportCode === queryParams?.toAirport || flight?.neareastToAirport === queryParams?.toAirport) {
                            isDeparture = false;
                        }
                    } else {
                        returnFlights.push(flight);
                    }
                }

                setFlightDetails({
                    departureFlights,
                    returnFlights,
                    multiCityData
                })
            }
        }
    }, [flights])

    useEffect(() => {
        if (roundTripDomestic?.status && roundTripDomestic?.active === 1 && selectedMultiflights?.length > 1) {
            const multiFlights = selectedMultiflights.find(flights => flights?.active);
            setActiveFlightOption(multiFlights);
        }
    }, [selectedMultiflights])

    useEffect(() => {
        setAlternateFareData({});
        setAlternateFareLoading({});
    }, [flights?.flightDHTRId]);

    const getAlternateKey = (flightData = {}) => {
        return `${flightData?.source || "unknown"}-${flightData?.flightDHTRId || flightData?.routingId || ""}`;
    };
    const getAljazeeraFareKey = (flightDHTRId, pricingData) => {
        if (!flightDHTRId || !pricingData) return null;
        return `${flightDHTRId}|${pricingData?.id ?? ""}|${pricingData?.bundleCode ?? ""}|${pricingData?.fareIdentifier ?? ""}`;
    };

    const shouldFetchAlternateVendorFare = (source = "") => {
        return ["amadeus", "air-arabia", "ndc-portal"].includes(String(source).toLowerCase());
    };

    const isMainPricingReadyFn = (flight) => {
        if (!flight) return false;
        const src = String(flight?.source || "").toLowerCase();
        if (src === "amadeus") {
            return !flight?.amaduesLoader
                && Array.isArray(flight?.amaduesFaresData?.pricing)
                && flight?.amaduesFaresData?.pricing?.length > 0;
        }
        if (src === "tripjack") {
            return !flight?.tripJackLoader
                && Array.isArray(flight?.pricing)
                && flight?.pricing?.length > 0;
        }
        if (src === "air-arabia") {
            return !flight?.airArabiaLoader && !!flight?.airArabiaFlightData;
        }
        if (src === "ndc-portal") {
            return !flight?.ndcLoader
                && Array.isArray(flight?.ndcFaresData?.pricing)
                && flight?.ndcFaresData?.pricing?.length > 0;
        }
        // verteil, akasa-air, travel-fusion, fly-dubai: pricing array is available immediately
        return Array.isArray(flight?.pricing) && flight?.pricing?.length > 0;
    };

    const extractFareDetailsForVendorFn = (source, pricingData) => {
        const src = String(source || "").toLowerCase();
        if (src === "amadeus") {
            const adultEntry = Array.isArray(pricingData?.passengers?.['ADULT'])
                ? pricingData?.passengers?.['ADULT']?.[0]
                : pricingData?.passengers?.['ADULT'];
            const childEntry = Array.isArray(pricingData?.passengers?.['CHILD'])
                ? pricingData?.passengers?.['CHILD']?.[0]
                : pricingData?.passengers?.['CHILD'];
            return {
                checkInBaggage: adultEntry?.baggage?.checked || childEntry?.baggage?.checked || 'N/A',
                cabinBaggage: adultEntry?.baggage?.cabin || childEntry?.baggage?.cabin || 'N/A',
                mealIndicator: false
            };
        }
        if (src === "tripjack") {
            const adultEntry = pricingData?.passengers?.['ADULT'];
            const childEntry = pricingData?.passengers?.['CHILD'];
            return {
                checkInBaggage: adultEntry?.baggage?.checked || childEntry?.baggage?.checked || 'N/A',
                cabinBaggage: adultEntry?.baggage?.cabin || childEntry?.baggage?.cabin || 'N/A',
                mealIndicator: adultEntry?.mealIndicator !== undefined
                    ? adultEntry?.mealIndicator
                    : (childEntry?.mealIndicator || false)
            };
        }
        if (src === "verteil") {
            const adultSegment = pricingData?.passengers?.['ADULT']?.segment?.[0];
            const childSegment = pricingData?.passengers?.['CHILD']?.segment?.[0];
            return {
                checkInBaggage: adultSegment?.baggage?.checked || childSegment?.baggage?.checked || 'N/A',
                cabinBaggage: adultSegment?.baggage?.cabin || childSegment?.baggage?.cabin || 'N/A',
                mealIndicator: false
            };
        }
        if (src === "fly-dubai") {
            const adultEntry = pricingData?.passengers?.['ADULT'];
            const childEntry = pricingData?.passengers?.['CHILD'];
            return {
                checkInBaggage: adultEntry?.baggage?.checked || childEntry?.baggage?.checked || 'N/A',
                cabinBaggage: adultEntry?.baggage?.cabin || childEntry?.baggage?.cabin || 'N/A',
                mealIndicator: adultEntry?.mealIndicator !== undefined
                    ? adultEntry?.mealIndicator
                    : (childEntry?.mealIndicator || false)
            };
        }
        if (src === "air-arabia") {
            return { checkInBaggage: 'Chargable', cabinBaggage: '10KG', mealIndicator: false };
        }
        if (src === "akasa-air") {
            const adtEntry = pricingData?.passengers?.['ADT'];
            const chdEntry = pricingData?.passengers?.['CHD'];
            return {
                checkInBaggage: adtEntry?.baggage?.checked || chdEntry?.baggage?.checked || '15 kg',
                cabinBaggage: adtEntry?.baggage?.cabin || chdEntry?.baggage?.cabin || '7 kg',
                mealIndicator: adtEntry?.mealIndicator !== undefined
                    ? adtEntry?.mealIndicator
                    : (chdEntry?.mealIndicator || false)
            };
        }
        if (src === "ndc-portal") {
            const passenger = pricingData?.passenger?.['ADT'] || pricingData?.passenger?.['CHD'];
            return {
                checkInBaggage: passenger?.baggage?.checkin || '',
                cabinBaggage: passenger?.baggage?.checked || '',
                mealIndicator: passenger?.mealIndicator || false
            };
        }
        if (src === "travel-fusion") {
            const adultEntry = pricingData?.passengers?.['ADULT'];
            const childEntry = pricingData?.passengers?.['CHILD'];
            return {
                checkInBaggage: adultEntry?.baggage?.checkinBaggage || childEntry?.baggage?.checkinBaggage || '',
                cabinBaggage: adultEntry?.baggage?.cabinBaggage || childEntry?.baggage?.cabinBaggage || '',
                mealIndicator: false
            };
        }
        // Fallback (mirrors prior generic logic)
        return {
            checkInBaggage: pricingData?.passengers?.['ADULT']?.baggage?.checked
                || pricingData?.passengers?.['CHILD']?.baggage?.checked
                || pricingData?.passengers?.['ADT']?.baggage?.checked
                || pricingData?.passengers?.['ADT']?.baggage?.checkin
                || '',
            cabinBaggage: pricingData?.passengers?.['ADULT']?.baggage?.cabin
                || pricingData?.passengers?.['CHILD']?.baggage?.cabin
                || pricingData?.passengers?.['ADT']?.baggage?.cabin
                || pricingData?.passengers?.['ADT']?.baggage?.checked
                || '',
            mealIndicator: pricingData?.passengers?.['ADULT']?.mealIndicator
                || pricingData?.passengers?.['CHILD']?.mealIndicator
                || pricingData?.passenger?.['ADT']?.mealIndicator
                || false
        };
    };

    const loadAlternateVendorFare = async (flightData) => {
        if (!flightData || !loadAlternateFlightFareData) return;
        const key = getAlternateKey(flightData);
        if (alternateFareData?.[key] || alternateFareLoading?.[key]) return;

        setAlternateFareLoading((prev) => ({ ...prev, [key]: true }));
        try {
            const fareData = await loadAlternateFlightFareData(flightData);
            setAlternateFareData((prev) => ({ ...prev, [key]: fareData || {} }));
        } catch (error) {
            console.error("Error loading alternate vendor fare:", error);
            setAlternateFareData((prev) => ({ ...prev, [key]: {} }));
        } finally {
            setAlternateFareLoading((prev) => ({ ...prev, [key]: false }));
        }
    };

    const getResolvedAlternateFlight = (flightData) => {
        const key = getAlternateKey(flightData);
        return {
            ...flightData,
            ...(alternateFareData?.[key] || {})
        };
    };

    const getAlternatePricingList = (flightData) => {
        const source = String(flightData?.source || "").toLowerCase();
        if (source === "amadeus") return flightData?.amaduesFaresData?.pricing || [];
        if (source === "ndc-portal") return flightData?.ndcFaresData?.pricing || [];
        return flightData?.pricing || [];
    };

    const sortPricingList = (pricingList = []) => {
        return [...pricingList].sort((a, b) => {
            const priceA = Number(a?.totalPrice) || 0;
            const priceB = Number(b?.totalPrice) || 0;
            return priceA - priceB;
        });
    };

    const dedupeSlidesByTotalPrice = (slides = []) => {
        const seenPrices = new Set();
        return slides.filter((slide) => {
            const price = Number(slide?.totalPrice) || 0;
            if (seenPrices.has(price)) return false;
            seenPrices.add(price);
            return true;
        });
    };

    const handleAlternateBook = (flightData, pricingData) => {
        const source = String(flightData?.source || "").toLowerCase();
        if (source === "amadeus") {
            flightBookingFn(flightData?.source, flightData, pricingData?.id, flightData?.amaduesFaresData);
            return;
        }
        if (source === "air-arabia") {
            flightBookingFn(
                flightData?.source,
                flightData,
                flightData?.airArabiaFlightData?.transactionId || flightData?.pricing?.[0]?.id,
                pricingData
            );
            return;
        }
        if (source === "ndc-portal") {
            if (pricingData?.bundle) {
                const pricingForBooking = getNdcPricingWithoutMarkupFn(pricingData);
                setSelectedNDCFare({
                    flights: flightData,
                    pricing: { ...pricingForBooking, id: pricingData?.mainOfferId },
                });
                handleBundleSelection(
                    pricingForBooking,
                    flightData?.source,
                    flightData,
                    { id: pricingData?.mainOfferId },
                    pricingForBooking
                );
                return;
            }
            flightBookingFn(flightData?.source, flightData, { id: pricingData?.id }, pricingData);
            return;
        }
        if (source === "aljazeera") {
            flightBookingFn(
                flightData?.source,
                flightData,
                { id: pricingData?.id, flightDHTRId: pricingData?.flightDHTRId ?? flightData?.flightDHTRId },
                pricingData
            );
            return;
        }
        if (source === "travel-fusion") {
            flightBookingFn(flightData?.source, flightData, pricingData);
            return;
        }
        if (source === "verteil") {
            // Verteil's booking handler reads `priceId.session` and `priceId.id` off the
            // 3rd argument, so we must pass the full pricing object (not just its id).
            flightBookingFn(flightData?.source, flightData, pricingData);
            return;
        }
        if (source === "fly-dubai") {
            // Fly-Dubai also reads `priceId.session`, `priceId.id`, `priceId.passengers`,
            // etc. off the 3rd argument — pass the full pricing object.
            flightBookingFn(flightData?.source, flightData, pricingData);
            return;
        }
        flightBookingFn(flightData?.source, flightData, pricingData?.id || pricingData);
    };

    useEffect(() => {
        if (!Array.isArray(flights?.uniqueGroup)) return;
        // Only start loading alternate vendor fares once the main vendor pricing is ready.
        if (!isMainPricingReadyFn(flights)) return;
        flights.uniqueGroup.forEach((groupFlight) => {
            if (shouldFetchAlternateVendorFare(groupFlight?.source)) {
                loadAlternateVendorFare(groupFlight);
            }
        });
    }, [
        flights?.uniqueGroup,
        flights?.amaduesLoader,
        flights?.amaduesFaresData,
        flights?.tripJackLoader,
        flights?.pricing,
        flights?.airArabiaLoader,
        flights?.airArabiaFlightData,
        flights?.ndcLoader,
        flights?.ndcFaresData
    ]);

    const buildMainVendorSlidesFn = () => {
        const src = String(flights?.source || "").toLowerCase();

        if (src === 'amadeus') {
            if (flights?.amaduesLoader) return { type: 'loader' };
            const pricingList = flights?.amaduesFaresData?.pricing;
            if (!pricingList?.length) return { type: 'error' };
            const slides = pricingList.map((pricing, pricingIndex) => {
                const checkIn = pricing?.passengers?.['ADULT'] ? pricing?.passengers?.['ADULT']?.[0]?.baggage?.checked : pricing?.passengers?.['CHILD']?.[0] ? pricing?.passengers?.['CHILD']?.baggage?.checked : 'N/A';
                const cabin = pricing?.passengers?.['ADULT'] ? pricing?.passengers?.['ADULT']?.[0]?.baggage?.cabin : pricing?.passengers?.['CHILD'] ? pricing?.passengers?.['CHILD']?.baggage?.cabin : 'N/A';
                return {
                    totalPrice: Number(pricing?.totalPrice) || 0,
                    element: (
                        <SwiperSlide key={`main-amadeus-${pricingIndex}`}>
                            <FareViewsHtmlComponent
                                fareIdentifier={pricing?.fareIdentifier}
                                totalPrice={pricing?.totalPrice}
                                agentActiveCurrency={agentActiveCurrency}
                                onClickFn={() => {
                                    flightBookingFn(flights?.source, flights, pricing?.id, flights?.amaduesFaresData);
                                }}
                                CheckInBagagge={checkIn}
                                cabbinBaggage={cabin}
                                mealIndicator={false}
                                fareRuleCancellationAmount={""}
                                vendor={flights?.source}
                                displayPrice={displayPrice}
                            />
                        </SwiperSlide>
                    )
                };
            });
            return { type: 'slides', slides };
        }

        if (src === 'tripjack') {
            if (flights?.tripJackLoader) return { type: 'loader' };
            const pricingList = flights?.pricing;
            if (!pricingList?.length) return { type: 'error' };
            const slides = pricingList.map((pricing, pricingIndex) => {
                const mealIndicator = pricing?.passengers?.['ADULT'] ? pricing?.passengers?.['ADULT']?.mealIndicator : pricing?.passengers?.['CHILD'] ? pricing?.passengers?.['CHILD']?.mealIndicator : false;
                const checkIn = pricing?.passengers?.['ADULT'] ? pricing?.passengers?.['ADULT']?.baggage?.checked : pricing?.passengers?.['CHILD'] ? pricing?.passengers?.['CHILD']?.baggage?.checked : 'N/A';
                const cabin = pricing?.passengers?.['ADULT'] ? pricing?.passengers?.['ADULT']?.baggage?.cabin : pricing?.passengers?.['CHILD'] ? pricing?.passengers?.['CHILD']?.baggage?.cabin : 'N/A';
                return {
                    totalPrice: Number(pricing?.totalPrice) || 0,
                    element: (
                        <SwiperSlide key={`main-tripjack-${pricingIndex}`}>
                            <FareViewsHtmlComponent
                                fareIdentifier={pricing?.fareIdentifier}
                                totalPrice={pricing?.totalPrice}
                                agentActiveCurrency={agentActiveCurrency}
                                onClickFn={() => {
                                    flightBookingFn(flights?.source, flights, pricing?.id);
                                }}
                                CheckInBagagge={checkIn}
                                cabbinBaggage={cabin}
                                mealIndicator={mealIndicator}
                                fareRuleCancellationAmount={""}
                                vendor={flights?.source}
                                roundTripDomestic={roundTripDomestic}
                                selectMultiFlightFn={() => {
                                    selectMultiFlightFn(flights, pricing, activeFlightOption);
                                }}
                                activeFlightOption={activeFlightOption}
                                priceId={pricing?.id}
                                displayPrice={displayPrice}
                            />
                        </SwiperSlide>
                    )
                };
            });
            return { type: 'slides', slides };
        }

        if (src === 'travel-fusion') {
            const pricingList = flights?.pricing;
            if (!pricingList?.length) return { type: 'error' };
            const slides = pricingList.map((pricing, pricingIndex) => {
                const checkInBaggage = pricing?.passengers?.['ADULT'] ? pricing?.passengers?.['ADULT']?.baggage?.checkinBaggage : pricing?.passengers?.['CHILD'] ? pricing?.passengers?.['CHILD']?.baggage?.checkinBaggage : '';
                const cabbinBaggage = pricing?.passengers?.['ADULT'] ? pricing?.passengers?.['ADULT']?.baggage?.cabinBaggage : pricing?.passengers?.['CHILD'] ? pricing?.passengers?.['CHILD']?.baggage?.cabinBaggage : '';
                return {
                    totalPrice: Number(pricing?.totalPrice) || 0,
                    element: (
                        <SwiperSlide key={`main-travel-fusion-${pricingIndex}`}>
                            <FareViewsHtmlComponent
                                fareIdentifier={pricing?.fareIdentifier}
                                totalPrice={pricing?.totalPrice}
                                agentActiveCurrency={agentActiveCurrency}
                                onClickFn={() => {
                                    flightBookingFn(flights?.source, flights, pricing)
                                }}
                                CheckInBagagge={checkInBaggage}
                                cabbinBaggage={cabbinBaggage}
                                mealIndicator={""}
                                fareRuleCancellationAmount={""}
                                vendor={flights?.source}
                                roundTripDomestic={roundTripDomestic}
                                selectMultiFlightFn={() => {
                                    selectMultiFlightFn(flights, pricing, activeFlightOption)
                                }}
                                activeFlightOption={activeFlightOption}
                                priceId={pricing?.id}
                                displayPrice={displayPrice}
                            />
                        </SwiperSlide>
                    )
                };
            });
            return { type: 'slides', slides };
        }

        if (src === 'air-arabia') {
            if (flights?.airArabiaLoader) return { type: 'loader' };
            if (!flights?.airArabiaFlightData) return { type: 'slides', slides: [], suffixSlides: [] };

            const slides = (flights?.pricing || []).map((service, index) => ({
                totalPrice: Number(service?.totalPrice) || 0,
                element: (
                    <SwiperSlide key={`main-air-arabia-${index}`}>
                        <FareViewsHtmlComponent
                            fareIdentifier={service?.fareIdentifier}
                            totalPrice={service?.totalPrice}
                            agentActiveCurrency={agentActiveCurrency}
                            onClickFn={() => {
                                flightBookingFn(flights?.source, flights, flights?.airArabiaFlightData?.transactionId, service)
                            }}
                            CheckInBagagge={"Chargable"}
                            cabbinBaggage={"10KG"}
                            mealIndicator={false}
                            fareRuleCancellationAmount={""}
                            description={service?.description}
                            vendor={flights?.source}
                            roundTripDomestic={roundTripDomestic}
                            selectMultiFlightFn={() => {
                                selectMultiFlightFn(flights,
                                    {
                                        id: flights?.airArabiaFlightData?.priceId,
                                        totalPrice: service?.totalPrice,
                                        passengers: service?.passengers
                                    },
                                    activeFlightOption)
                            }}
                            activeFlightOption={activeFlightOption}
                            priceId={flights?.airArabiaFlightData?.priceId}
                            displayPrice={displayPrice}
                        />
                    </SwiperSlide>
                )
            }));

            const suffixSlides = (flights?.airArabiaFlightData?.bundleService || []).map((service, index) => {
                // eslint-disable-next-line no-unused-vars
                const isSelected = selectedAirArabiaBundle && Array.isArray(selectedAirArabiaBundle) && selectedAirArabiaBundle.some(bundle => bundle.serviceId === service.serviceId);
                return (
                    <SwiperSlide key={`main-air-arabia-bundle-${index}`}>
                        <FareViewsHtmlComponent
                            fareIdentifier={service?.serviceName}
                            totalPrice={service?.price}
                            agentActiveCurrency={agentActiveCurrency}
                            onClickFn={() => {
                                onSelectAirArabiaBundle(service, "OneWay");
                                flightBookingFn(flights?.source, flights, flights?.airArabiaFlightData?.transactionId, flights?.pricing[index] ? flights?.pricing[index] : flights?.pricing[0], service)
                            }}
                            CheckInBagagge={""}
                            cabbinBaggage={""}
                            mealIndicator={false}
                            fareRuleCancellationAmount={""}
                            description={service?.description}
                            vendor={flights?.source}
                            roundTripDomestic={roundTripDomestic}
                            selectMultiFlightFn={() => {
                                let tripType = 'UNKNOWN';
                                if (roundTripDomestic?.status && roundTripDomestic?.active === 1) {
                                    if (selectedMultiflights?.length === 0) {
                                        tripType = 'ONWARD';
                                    } else if (selectedMultiflights?.length === 1) {
                                        tripType = 'RETURN';
                                    }
                                } else {
                                    tripType = 'SINGLE';
                                }
                                onSelectAirArabiaBundle(service, tripType);
                                selectMultiFlightFn(flights,
                                    {
                                        id: service?.serviceId,
                                        totalPrice: service?.price,
                                        passengers: flights?.pricing[index] ? flights?.pricing[index]?.passengers : flights?.pricing[0]?.passengers,
                                        bundleData: service
                                    },
                                    activeFlightOption)
                            }}
                            activeFlightOption={activeFlightOption}
                            priceId={service?.serviceId}
                            displayPrice={displayPrice}
                        />
                    </SwiperSlide>
                );
            });

            return { type: 'slides', slides, suffixSlides };
        }

        if (src === 'akasa-air') {
            const pricingList = flights?.pricing;
            if (!pricingList?.length) return { type: 'error' };
            const slides = pricingList.map((pricingData, pricingIndex) => {
                const checkInBaggage = pricingData?.passengers?.['ADT'] ? pricingData?.passengers?.['ADT']?.baggage?.checked : pricingData?.passengers?.['CHD'] ? pricingData?.passengers?.['CHD']?.baggage?.checked : '15 kg';
                const cabbinBaggage = pricingData?.passengers?.['ADT'] ? pricingData?.passengers?.['ADT']?.baggage?.cabin : pricingData?.passengers?.['CHD'] ? pricingData?.passengers?.['CHD']?.baggage?.cabin : '7 kg';
                const mealIndicator = pricingData?.passengers?.['ADT'] ? pricingData?.passengers?.['ADT']?.mealIndicator : pricingData?.passengers?.['CHD'] ? pricingData?.passengers?.['CHD']?.mealIndicator : false;
                return {
                    totalPrice: Number(pricingData?.totalPrice) || 0,
                    element: (
                        <SwiperSlide key={`main-akasa-air-${pricingIndex}`}>
                            <FareViewsHtmlComponent
                                fareIdentifier={pricingData?.fareIdentifier}
                                totalPrice={pricingData.totalPrice}
                                agentActiveCurrency={agentActiveCurrency}
                                onClickFn={() => {
                                    flightBookingFn(flights?.source, flights, pricingData)
                                }}
                                CheckInBagagge={checkInBaggage}
                                cabbinBaggage={cabbinBaggage}
                                mealIndicator={mealIndicator}
                                fareRuleCancellationAmount={""}
                                description=''
                                vendor={flights?.source}
                                roundTripDomestic={roundTripDomestic}
                                selectMultiFlightFn={() => {
                                    selectMultiFlightFn(flights, pricingData, activeFlightOption)
                                }}
                                activeFlightOption={activeFlightOption}
                                priceId={pricingData?.id}
                                displayPrice={displayPrice}
                            />
                        </SwiperSlide>
                    )
                };
            });
            return { type: 'slides', slides };
        }

        if (src === 'ndc-portal') {
            if (flights?.ndcLoader) return { type: 'loader' };
            const pricingList = flights?.ndcFaresData?.pricing;
            if (!pricingList?.length) return { type: 'error' };
            const slides = pricingList.map((pricingData, pricingIndex) => {
                const passengerData = pricingData?.passenger?.['ADT'] || pricingData?.passenger?.['CHD'];
                const checkInBaggage = passengerData?.baggage?.checkin || '';
                const cabbinBaggage = passengerData?.baggage?.checked || '';
                const mealIndicator = passengerData?.mealIndicator || false;
                return {
                    totalPrice: getEffectiveTotalPriceFn(pricingData),
                    element: (
                        <SwiperSlide key={`main-ndc-${pricingIndex}`}>
                            <FareViewsHtmlComponent
                                fareIdentifier={pricingData?.fareIdentifier}
                                totalPrice={pricingData.totalPrice}
                                agentActiveCurrency={agentActiveCurrency}
                                onClickFn={() => {
                                    if (pricingData?.bundle) {
                                        const pricingForBooking = getNdcPricingWithoutMarkupFn(pricingData);
                                        const pricing = {
                                            ...pricingForBooking,
                                            id: pricingData?.mainOfferId,
                                        };
                                        setSelectedNDCFare({ flights, pricing });
                                        handleBundleSelection(pricingForBooking, flights?.source, flights, { id: pricingData?.mainOfferId }, pricingForBooking);
                                    } else {
                                        flightBookingFn(flights?.source, flights, { id: pricingData?.id }, pricingData)
                                    }
                                }}
                                CheckInBagagge={checkInBaggage}
                                cabbinBaggage={cabbinBaggage}
                                mealIndicator={mealIndicator}
                                fareRuleCancellationAmount={""}
                                description=''
                                vendor={flights?.source}
                                roundTripDomestic={roundTripDomestic}
                                selectMultiFlightFn={() => {
                                    selectMultiFlightFn(flights, pricingData, activeFlightOption)
                                }}
                                activeFlightOption={activeFlightOption}
                                priceId={pricingData?.id}
                                haveBundles={pricingData?.bundle}
                                bundleData={pricingData}
                                showBundles={showBundles}
                                setBundle={() => handleNDCSelect(pricingData?.id, flights, pricingData)}
                                displayPrice={displayPrice}
                            />
                        </SwiperSlide>
                    )
                };
            });
            return { type: 'slides', slides };
        }

        if (src === 'verteil') {
            const pricingList = flights?.pricing;
            if (!pricingList?.length) return { type: 'error' };
            const slides = pricingList.map((pricingData, pricingIndex) => {
                const checkInBaggage = pricingData?.passengers?.['ADULT'] ? pricingData?.passengers?.['ADULT']?.segment?.[0]?.baggage?.checked : pricingData?.passengers?.['CHILD'] ? pricingData?.passengers?.['CHILD']?.segment?.[0]?.baggage?.checked : 'N/A';
                const cabbinBaggage = pricingData?.passengers?.['ADULT'] ? pricingData?.passengers?.['ADULT']?.segment?.[0]?.baggage?.cabin : pricingData?.passengers?.['CHILD'] ? pricingData?.passengers?.['CHILD']?.segment?.[0]?.baggage?.cabin : 'N/A';
                const mealIndicator = false;
                return {
                    totalPrice: Number(pricingData?.totalPrice) || 0,
                    element: (
                        <SwiperSlide key={`main-verteil-${pricingIndex}`}>
                            <FareViewsHtmlComponent
                                fareIdentifier={pricingData?.fareIdentifier}
                                totalPrice={pricingData.totalPrice}
                                agentActiveCurrency={agentActiveCurrency}
                                onClickFn={() => {
                                    flightBookingFn(flights?.source, flights, pricingData)
                                }}
                                CheckInBagagge={checkInBaggage}
                                cabbinBaggage={cabbinBaggage}
                                mealIndicator={mealIndicator}
                                fareRuleCancellationAmount={""}
                                description=''
                                vendor={flights?.source}
                                roundTripDomestic={roundTripDomestic}
                                selectMultiFlightFn={() => {
                                    selectMultiFlightFn(flights, pricingData, activeFlightOption)
                                }}
                                activeFlightOption={activeFlightOption}
                                priceId={pricingData?.id}
                                displayPrice={displayPrice}
                            />
                        </SwiperSlide>
                    )
                };
            });
            return { type: 'slides', slides };
        }

        if (src === 'fly-dubai') {
            const pricingList = flights?.pricing;
            if (!pricingList?.length) return { type: 'error' };
            const slides = pricingList.map((pricingData, pricingIndex) => {
                const checkInBaggage = pricingData?.passengers?.['ADULT'] ? pricingData?.passengers?.['ADULT']?.baggage?.checked : pricingData?.passengers?.['CHILD'] ? pricingData?.passengers?.['CHILD']?.baggage?.checked : 'N/A';
                const cabbinBaggage = pricingData?.passengers?.['ADULT'] ? pricingData?.passengers?.['ADULT']?.baggage?.cabin : pricingData?.passengers?.['CHILD'] ? pricingData?.passengers?.['CHILD']?.baggage?.cabin : 'N/A';
                const mealIndicator = pricingData?.passengers?.['ADULT'] ? pricingData?.passengers?.['ADULT']?.mealIndicator : pricingData?.passengers?.['CHILD'] ? pricingData?.passengers?.['CHILD']?.mealIndicator : false;
                return {
                    totalPrice: Number(pricingData?.totalPrice) || 0,
                    element: (
                        <SwiperSlide key={`main-fly-dubai-${pricingIndex}`}>
                            <FareViewsHtmlComponent
                                fareIdentifier={pricingData?.fareIdentifier}
                                totalPrice={pricingData.totalPrice}
                                agentActiveCurrency={agentActiveCurrency}
                                onClickFn={() => {
                                    flightBookingFn(flights?.source, flights, pricingData)
                                }}
                                CheckInBagagge={checkInBaggage}
                                cabbinBaggage={cabbinBaggage}
                                mealIndicator={mealIndicator}
                                fareRuleCancellationAmount={""}
                                description=''
                                vendor={flights?.source}
                                roundTripDomestic={roundTripDomestic}
                                selectMultiFlightFn={() => {
                                    selectMultiFlightFn(flights, pricingData, activeFlightOption)
                                }}
                                activeFlightOption={activeFlightOption}
                                priceId={pricingData?.id}
                                type={flights?.tripType}
                                isCompatible={true}
                                displayPrice={displayPrice}
                            />
                        </SwiperSlide>
                    )
                };
            });
            return { type: 'slides', slides };
        } 
        if (src === 'aljazeera') {
            const pricingList = flights?.pricing;
            if (!pricingList?.length) return { type: 'error' };
            const slides = pricingList.map((pricingData, pricingIndex) => {
                const passengerData = pricingData?.passengers?.['ADULT'] || pricingData?.passenger?.['CHILD'];
                const checkInBaggage = passengerData?.baggage?.checked || '';
                const cabbinBaggage = '7 kg';
                const mealIndicator = passengerData?.mealIndicator || false;
                return {
                    totalPrice: Number(pricingData?.totalPrice) || 0,
                    element: (
                        <SwiperSlide key={`main-ndc-${pricingIndex}`}>
                            <FareViewsHtmlComponent
                                fareIdentifier={pricingData?.fareIdentifier}
                                totalPrice={pricingData.totalPrice}
                                agentActiveCurrency={agentActiveCurrency}
                                onClickFn={() => { flightBookingFn(flights?.source, flights, { id: pricingData?.id, flightDHTRId: pricingData?.flightDHTRId }, pricingData) }}
                                CheckInBagagge={checkInBaggage}
                                cabbinBaggage={cabbinBaggage}
                                fareRuleCancellationAmount={""}
                                vendor={flights?.source}
                                roundTripDomestic={roundTripDomestic}
                                selectMultiFlightFn={() => {
                                    selectMultiFlightFn(flights, pricingData, activeFlightOption)
                                }}
                                activeFlightOption={activeFlightOption}
                                priceId={pricingData?.id}
                                displayPrice={displayPrice}
                                features={pricingData?.bundleInclusions}
                                selectionId={getAljazeeraFareKey(flights?.flightDHTRId, pricingData)}
                                selectedId={getAljazeeraFareKey(activeFlightOption?.flightDHTRId, activeFlightOption?.priceId)}
                            />
                        </SwiperSlide>
                    )
                };
            });
            return { type: 'slides', slides };
        }

        return { type: 'slides', slides: [] };
    };

    const renderAlternatePricingSlides = () => {
        if (!Array.isArray(flights?.uniqueGroup) || !flights?.uniqueGroup?.length) return [];
        // Wait until the main vendor's pricing is loaded before showing any alternates.
        if (!isMainPricingReadyFn(flights)) return [];

        return flights?.uniqueGroup?.flatMap((groupFlight) => {
            const source = String(groupFlight?.source || "").toLowerCase();
            const key = getAlternateKey(groupFlight);
            const isApiVendor = shouldFetchAlternateVendorFare(source);
            const isLoading = !!alternateFareLoading?.[key];
            const resolvedFlight = getResolvedAlternateFlight(groupFlight);
            const pricingList = sortPricingList(getAlternatePricingList(resolvedFlight));

            // While an alternate vendor's data is still being fetched, render nothing for it
            // (no skeleton slides — the main vendor loader already covered the initial state).
            if (isApiVendor && isLoading) return [];
            if (!pricingList?.length) return [];

            return pricingList?.map((pricingData, pricingIndex) => {
                const { checkInBaggage, cabinBaggage, mealIndicator } = extractFareDetailsForVendorFn(source, pricingData);

                return {
                    totalPrice: getEffectiveTotalPriceFn(pricingData),
                    element: (
                        <SwiperSlide key={`${key}-pricing-${pricingIndex}`}>
                            <FareViewsHtmlComponent
                                fareIdentifier={`${pricingData?.fareIdentifier || ''}`}
                                totalPrice={pricingData?.totalPrice}
                                haveBundles={pricingData?.bundle}
                                bundleData={pricingData}
                                agentActiveCurrency={agentActiveCurrency}
                                onClickFn={() => handleAlternateBook(resolvedFlight, pricingData)}
                                CheckInBagagge={checkInBaggage}
                                cabbinBaggage={cabinBaggage}
                                mealIndicator={mealIndicator}
                                fareRuleCancellationAmount={""}
                                description=''
                                vendor={resolvedFlight?.source}
                                roundTripDomestic={roundTripDomestic}
                                selectMultiFlightFn={() => {
                                    selectMultiFlightFn(resolvedFlight, pricingData, activeFlightOption)
                                }}
                                activeFlightOption={activeFlightOption}
                                priceId={pricingData?.id}
                                displayPrice={displayPrice}
                            />
                        </SwiperSlide>
                    )
                };
            });
        });
    };

    // const isFlyDubaiCompatible = (currentFlight, pricingData) => {
    //     if (currentFlight?.source !== 'fly-dubai' || currentFlight?.tripType !== 'RETURN') {
    //         return true;
    //     }
    //     const combinationData = JSON.parse(sessionStorage.getItem('fly-dubai-Combination'));
    //     if (!combinationData || !Array.isArray(combinationData)) {
    //         return false;
    //     }
    //     const selectedOnwardFlight = selectedMultiflights.find(flight =>
    //         flight?.type === 'ONWARD'
    //     );
    //     if (!selectedOnwardFlight) {
    //         return false;
    //     }
    //     const matchingCombination = combinationData.find(combo =>
    //         combo.SolnRef && combo.SolnRef[0] === selectedOnwardFlight.priceId?.id
    //     );
    //     if (!matchingCombination) {
    //         return false;
    //     }
    //     return matchingCombination.SolnRef && matchingCombination.SolnRef[1] === pricingData?.id;
    // };

    const handleNDCSelect = async (offerID, flights, pricingData) => {
        setSelectedNDCFare({ flights, pricingData });
        setShowNDCPopup(true);
        if (!bundleData) {
            setBundleLoading(true);
            setBundleData(null);
            setSelectedBundle(null);

            try {
                const response = await ApiCall('POST', '/flights/flight-bundle-data', { offerid: offerID, type: 'ndc-portal' }, { authorization: userToken });
                if (response?.status === 200 && response?.data?.statusCode === 200) {
                    setBundleData(response?.data?.data?.bundles);
                }
            } catch (error) {
                console.error('Error fetching bundle data:', error);
                setBundleData({ error: 'Failed to load bundle data' });
            } finally {
                setBundleLoading(false);
            }
        }
    };

    const handleBundleSelection = (bundle, source, flights, id, pricingData) => {
        setSelectedBundle(bundle);
        sessionStorage.setItem('ndcDataBundle', JSON.stringify(bundle))
        // let originalData = JSON.parse(localStorage.getItem('ndcData'))
        // if (originalData) {
        //     originalData['selectedBundle'] = bundle
        // }
        // localStorage.setItem('ndcData', JSON.stringify(originalData))
        flightBookingFn(
            source,
            flights,
            { id: id?.id },
            pricingData
        );
    };

    const headerSummary = (() => {
        // Multi-City Combo
        const multiCityKeys = Object.keys(flightDetails?.multiCityData || {});
        if (multiCityKeys.length > 0) {
            const firstCityFlights = flightDetails.multiCityData[multiCityKeys[0]]?.flights || [];
            const lastCityFlights = flightDetails.multiCityData[multiCityKeys[multiCityKeys.length - 1]]?.flights || [];
            const firstSeg = firstCityFlights[0] || flights?.segments?.[0];

            const stations = [];
            multiCityKeys.forEach((key) => {
                const segs = flightDetails.multiCityData[key]?.flights || [];
                if (segs.length > 0) {
                    const fromCode = segs[0]?.departure?.airportCode || segs[0]?.neareastFromAirport || '';
                    const toCode = segs[segs.length - 1]?.arrival?.airportCode || segs[segs.length - 1]?.neareastToAirport || '';
                    if (stations.length === 0) {
                        if (fromCode) stations.push(fromCode);
                        if (toCode) stations.push(toCode);
                    } else {
                        if (stations[stations.length - 1] !== fromCode && fromCode) {
                            stations.push(fromCode);
                        }
                        if (toCode) stations.push(toCode);
                    }
                }
            });

            if (stations.length === 0 && Array.isArray(queryParams?.segments)) {
                queryParams.segments.forEach((seg) => {
                    if (stations.length === 0) {
                        if (seg?.fromAirport) stations.push(seg.fromAirport);
                        if (seg?.toAirport) stations.push(seg.toAirport);
                    } else {
                        if (stations[stations.length - 1] !== seg?.fromAirport && seg?.fromAirport) {
                            stations.push(seg.fromAirport);
                        }
                        if (seg?.toAirport) stations.push(seg.toAirport);
                    }
                });
            }

            const startDate = firstCityFlights[0]?.departure?.departureTime || queryParams?.segments?.[0]?.departDate;
            const endDate = lastCityFlights[0]?.departure?.departureTime || queryParams?.segments?.[queryParams.segments.length - 1]?.departDate;

            return {
                airlineCode: firstSeg?.flightCode || flights?.flightCode || '',
                airlineName: firstSeg?.flightName || flights?.flightName || 'Flight',
                stations: stations.length ? stations : [queryParams?.fromAirport || '', queryParams?.toAirport || ''].filter(Boolean),
                dateText: formatHeaderDateRange(startDate, endDate),
                timeRangeText: null,
                badgeText: 'Multi-City'
            };
        }

        // Round-Trip Combo
        if (flightDetails?.departureFlights?.length && flightDetails?.returnFlights?.length) {
            const depFirst = flightDetails.departureFlights[0];
            const depLast = flightDetails.departureFlights[flightDetails.departureFlights.length - 1];
            const retFirst = flightDetails.returnFlights[0];
            const retLast = flightDetails.returnFlights[flightDetails.returnFlights.length - 1];

            const depOrigin = depFirst?.departure?.airportCode || queryParams?.fromAirport || '';
            const depDest = depLast?.arrival?.airportCode || retFirst?.departure?.airportCode || queryParams?.toAirport || '';
            const retDest = retLast?.arrival?.airportCode || depOrigin || queryParams?.fromAirport || '';

            const stations = [];
            if (depOrigin) stations.push(depOrigin);
            if (depDest) stations.push(depDest);
            if (retDest) {
                stations.push(retDest);
            } else if (depOrigin) {
                stations.push(depOrigin);
            }

            const startDate = depFirst?.departure?.departureTime;
            const endDate = retFirst?.departure?.departureTime;

            return {
                airlineCode: depFirst?.flightCode || flights?.flightCode || '',
                airlineName: depFirst?.flightName || flights?.flightName || 'Flight',
                stations: stations.length ? stations : [depOrigin, depDest, depOrigin].filter(Boolean),
                dateText: formatHeaderDateRange(startDate, endDate),
                timeRangeText: null,
                badgeText: 'Round Trip'
            };
        }

        // One-Way Flight
        const firstSeg = flightDetails?.departureFlights?.[0] || flights?.segments?.[0];
        const lastSeg = (flightDetails?.departureFlights?.length ? flightDetails.departureFlights[flightDetails.departureFlights.length - 1] : null) || flights?.segments?.[flights?.segments?.length - 1];

        const origin = firstSeg?.departure?.airportCode || flights?.fromAirport || queryParams?.fromAirport || '';
        const dest = lastSeg?.arrival?.airportCode || flights?.toAirport || queryParams?.toAirport || '';
        const depTime = firstSeg?.departure?.departureTime;
        const arrTime = lastSeg?.arrival?.arrivalTime;
        const segCount = (flightDetails?.departureFlights?.length || flights?.segments?.length || 1);
        const stops = segCount > 1 ? segCount - 1 : 0;

        return {
            airlineCode: firstSeg?.flightCode || flights?.flightCode || '',
            airlineName: firstSeg?.flightName || flights?.flightName || 'Flight',
            stations: [origin, dest].filter(Boolean),
            dateText: formatHeaderDateWithSuffix(depTime),
            timeRangeText: (depTime && arrTime) ? `${formatHeaderTime(depTime)} - ${formatHeaderTime(arrTime)}` : null,
            badgeText: stops === 0 ? 'Non Stop' : `${stops} Stop${stops > 1 ? 's' : ''}`
        };
    })();

    const renderItineraryTimeline = (segmentsList) => {
        if (!segmentsList || !segmentsList.length) return null;

        const formatPointDate = (dateString) => {
            if (!dateString) return null;
            const d = new Date(dateString);
            if (isNaN(d.getTime())) return null;
            return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
        };

        const cleanAirportName = (city, airportName) => {
            const c = (city || '').trim();
            const a = (airportName || '').trim();
            if (!c && !a) return '';
            if (!c) return a;
            if (!a) return c;
            if (a.toLowerCase().includes(c.toLowerCase())) {
                return a;
            }
            return `${c} ${a}`;
        };

        const cleanTerminal = (terminal) => {
            if (!terminal) return '';
            const t = String(terminal).trim();
            if (!t || t.toUpperCase() === 'N/A' || t.toUpperCase() === 'NA' || t.toUpperCase() === 'NONE' || t === '-') {
                return '';
            }
            return t.toUpperCase().startsWith('T') ? t.toUpperCase() : `T${t}`;
        };

        return (
            <div className="hw-flight-timeline">
                {segmentsList.map((seg, idx) => {
                    const isFirstSeg = idx === 0;
                    const isLastSeg = idx === segmentsList.length - 1;
                    const nextSeg = segmentsList[idx + 1];

                    const depTime = formatHeaderTime(seg?.departure?.departureTime);
                    const arrTime = formatHeaderTime(seg?.arrival?.arrivalTime);

                    const depDate = formatPointDate(seg?.departure?.departureTime);
                    const arrDate = formatPointDate(seg?.arrival?.arrivalTime);

                    const depCode = seg?.departure?.airportCode || seg?.departure?.cityCode || '';
                    const depName = cleanAirportName(seg?.departure?.city, seg?.departure?.airportName);
                    const depTerminal = cleanTerminal(seg?.departure?.terminal);

                    const arrCode = seg?.arrival?.airportCode || seg?.arrival?.cityCode || '';
                    const arrName = cleanAirportName(seg?.arrival?.city, seg?.arrival?.airportName);
                    const arrTerminal = cleanTerminal(seg?.arrival?.terminal);

                    const layoverCity = nextSeg?.departure?.city || seg?.arrival?.city || '';
                    const layoverCode = nextSeg?.departure?.airportCode || seg?.arrival?.airportCode || '';
                    const layoverDuration = nextSeg ? differenceBetweenTwoDatesWithTime(seg?.arrival?.arrivalTime, nextSeg?.departure?.departureTime) : '';

                    return (
                        <React.Fragment key={`itinerary-seg-${idx}`}>
                            {/* Segment Departure Step */}
                            <div className="hw-tl-step">
                                <span className={`hw-tl-node ${isFirstSeg ? 'is-start' : 'is-mid'}`} />
                                <div className="hw-tl-main-row">
                                    <div className="hw-tl-datetime">
                                        {depDate && (
                                            <span className="hw-tl-date">
                                                {depDate}
                                            </span>
                                        )}
                                        {depDate && <span className="hw-tl-comma"> , </span>}
                                        <span className="hw-tl-time">{depTime}</span>
                                    </div>
                                    <span className="hw-tl-code">{depCode}</span>
                                    <span className="hw-tl-name">{depName}</span>
                                    {depTerminal && <span className="hw-tl-terminal-badge">{depTerminal}</span>}
                                </div>
                                <div className="hw-tl-sub-row">
                                    <span className="hw-tl-airline-info">
                                        {seg?.flightName} · {seg?.flightCode}{seg?.flightNumber}
                                    </span>
                                    <span className="hw-tl-bullet">•</span>
                                    <span className="hw-tl-duration-info">
                                        <svg className="hw-tl-clock-icon" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <circle cx="12" cy="12" r="10" />
                                            <polyline points="12 6 12 12 16 14" />
                                        </svg>
                                        <span>Flight time: {convertMinutesFn(seg?.duration)}</span>
                                    </span>
                                </div>
                            </div>

                            {/* Segment Arrival Step */}
                            <div className="hw-tl-step">
                                <span className={`hw-tl-node ${isLastSeg ? 'is-end' : 'is-mid'}`} />
                                <div className="hw-tl-main-row">
                                    <div className="hw-tl-datetime">
                                        {arrDate && (
                                            <span className="hw-tl-date">
                                                {arrDate}
                                            </span>
                                        )}
                                        {arrDate && <span className="hw-tl-comma"> , </span>}
                                        <span className="hw-tl-time">{arrTime}</span>
                                    </div>
                                    <span className="hw-tl-code">{arrCode}</span>
                                    <span className="hw-tl-name">{arrName}</span>
                                    {arrTerminal && <span className="hw-tl-terminal-badge">{arrTerminal}</span>}
                                </div>
                            </div>

                            {/* Layover Banner Step (if intermediate stop) */}
                            {nextSeg && (
                                <div className="hw-tl-step is-layover-step">
                                    <span className="hw-tl-node is-layover" />
                                    <div className="hw-tl-layover-banner">
                                        <div className="hw-tl-layover-left">
                                            <svg className="hw-tl-layover-clock" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#d97706" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                                                <circle cx="12" cy="12" r="10" />
                                                <polyline points="12 6 12 12 16 14" />
                                            </svg>
                                            <span className="hw-tl-layover-text">
                                                Layover in {layoverCity}{layoverCode ? ` (${layoverCode})` : ''}: {layoverDuration}
                                            </span>
                                        </div>
                                        <div className="hw-tl-layover-badge">
                                            <FlightIcon/>
                                            <span>Plane Change</span>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </React.Fragment>
                    );
                })}
            </div>
        );
    };

    return (
        <>
            <div className={`hw-modal hw-modal--flightBook fade ${openFareViews ? 'show' : ''}`}>
                <div className="hw-modal-dialog hw-modal-dialog-centered hw-modal-dialog-scrollable">
                    <div className="hw-modal-content">
                        {/* Heading Text: Fares options available for you */}
                        <div className="hw-fare-modal-top-bar">
                            <h3 className="hw-fare-modal-title">Fares Options available for you</h3>
                            <button
                                onClick={() => {
                                    setOpenFareViews(!openFareViews);
                                }}
                                className="hw-fare-header-close"
                                type="button"
                                aria-label="Close"
                            >
                                <CloseIcon />
                            </button>
                        </div>

                        {/* Collapsible Flight Summary Bar */}
                        <div
                            className="hw-fare-collapse-bar"
                            onClick={() => setShowFlightDetails(!showFlightDetails)}
                        >
                            <div className="hw-fare-collapse-bar-left">
                                {headerSummary.airlineCode && (
                                    <img
                                        className="hw-fare-header-airline-img"
                                        src={airlineImageFn(headerSummary.airlineCode)}
                                        alt={headerSummary.airlineName}
                                        onError={(e) => { e.target.style.display = 'none'; }}
                                    />
                                )}
                                <span className="hw-fare-collapse-airline">{headerSummary.airlineName}</span>
                                {headerSummary.stations?.map((stationCode, sIdx) => (
                                    <React.Fragment key={`summary-station-${sIdx}`}>
                                        <span className="hw-fare-collapse-station">{stationCode}</span>
                                        {sIdx < headerSummary.stations.length - 1 && (
                                            <span className="hw-fare-collapse-blue-arrow">
                                                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                                    <line x1="5" y1="12" x2="19" y2="12" />
                                                    <polyline points="12 5 19 12 12 19" />
                                                </svg>
                                            </span>
                                        )}
                                    </React.Fragment>
                                ))}
                                {headerSummary.dateText && (
                                    <span className="hw-fare-collapse-meta-text">
                                        {headerSummary.dateText}
                                    </span>
                                )}
                                {headerSummary.timeRangeText && (
                                    <>
                                        <span className="hw-fare-collapse-dot">·</span>
                                        <span className="hw-fare-collapse-meta-text">
                                            {headerSummary.timeRangeText}
                                        </span>
                                    </>
                                )}
                                {headerSummary.badgeText && (
                                    <>
                                        <span className="hw-fare-collapse-dot">·</span>
                                        <span className="hw-fare-collapse-meta-text">
                                            {headerSummary.badgeText}
                                        </span>
                                    </>
                                )}
                            </div>
                            <div className={`hw-fare-collapse-toggle-icon ${showFlightDetails ? 'is-open' : ''}`} aria-label="Toggle flight details">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="6 9 12 15 18 9" />
                                </svg>
                            </div>
                        </div>

                        <div className="hw-modal-body">
                            <div className={`hw-fare-drawer-wrapper ${showFlightDetails ? 'is-open' : ''}`}>
                                <div className="hw-fare-drawer-inner">
                                    <div className="hw-fare-itinerary-drawer">
                                        {flights?.tripType === 'COMBO' ? (
                                            Object?.keys(flightDetails?.multiCityData || {})?.length ? (
                                                Object.keys(flightDetails.multiCityData).map((flightIndex, flightIndexKey) => (
                                                    <div key={`multi-city-${flightIndexKey}`} className="hw-itinerary-combo-section">
                                                        <div className="hw-itinerary-section-heading">Flight {flightIndexKey + 1}</div>
                                                        {renderItineraryTimeline(flightDetails.multiCityData[flightIndex]?.flights)}
                                                    </div>
                                                ))
                                            ) : (
                                                <>
                                                    <div className="hw-itinerary-combo-section">
                                                        <div className="hw-itinerary-section-heading">Departure Flight</div>
                                                        {renderItineraryTimeline(flightDetails?.departureFlights)}
                                                    </div>
                                                    {flightDetails?.returnFlights?.length > 0 && (
                                                        <div className="hw-itinerary-combo-section mt-3">
                                                            <div className="hw-itinerary-section-heading">Return Flight</div>
                                                            {renderItineraryTimeline(flightDetails?.returnFlights)}
                                                        </div>
                                                    )}
                                                </>
                                            )
                                        ) : (
                                            renderItineraryTimeline(flights?.segments)
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className='hw-modal--bodyFares'>
                                {((roundTripDomestic?.status && roundTripDomestic?.active === 1) && flights?.source === 'travel-fusion') && (
                                    <div className="d-flex hw-gapy10 hw-fare--listPointItem" style={{ fontSize: "1.3rem", color: "#eb3333", marginBottom: "1rem" }}>
                                        <span>Note:</span>
                                        <div>Select a fare for one trip, and then use the same fare for the other trip.</div>
                                    </div>
                                )}

                                <div className='hw-fare--slider'>
                                    <Swiper
                                        spaceBetween={20}
                                        slidesPerView="auto"
                                        modules={[Navigation, Mousewheel, FreeMode]}
                                        navigation
                                        freeMode={{ enabled: true }}
                                        mousewheel={{
                                            enabled: true,
                                            sensitivity: 0.5,
                                            releaseOnEdges: true
                                        }}
                                    >
                                        {(() => {
                                            const mainResult = buildMainVendorSlidesFn();
                                            if (mainResult?.type === 'loader') return renderFareSkeletonSlides();
                                            if (mainResult?.type === 'error') return <ErrorFaresComponent />;

                                            const mainSlides = Array.isArray(mainResult?.slides) ? mainResult.slides : [];
                                            const suffixSlides = Array.isArray(mainResult?.suffixSlides) ? mainResult.suffixSlides : [];
                                            const altSlides = isShowFlightAlternateOption ? renderAlternatePricingSlides() : [];

                                            // Merge main + alternate vendor slides, sort by totalPrice ascending,
                                            // then show each price only once (main vendor kept when prices match).
                                            const combined = dedupeSlidesByTotalPrice(
                                                [...mainSlides, ...altSlides].sort((a, b) => {
                                                    const priceA = Number(a?.totalPrice) || 0;
                                                    const priceB = Number(b?.totalPrice) || 0;
                                                    return priceA - priceB;
                                                })
                                            );

                                            const sortedSlideElements = combined.map((item) => item?.element);

                                            if (!sortedSlideElements.length && !suffixSlides.length) {
                                                return <ErrorFaresComponent />;
                                            }

                                            return (
                                                <>
                                                    {sortedSlideElements}
                                                    {suffixSlides}
                                                </>
                                            );
                                        })()}
                                    </Swiper>
                                </div>
                            </div>

                            {/*</div>*/}
                        </div>
                    </div>
                </div>
            </div>
            <CommonPopup
                show={showNDCPopup}
                setShow={setShowNDCPopup}
                title="Select Bundle"
            >
                {selectedNDCFare && (
                    <div className="hw-ndc-bundle-container">
                        {bundleLoading ? (
                            <div className="hw-ndc-bundle-loading" style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                padding: '40px 20px'
                            }}>
                                <div className="hw-main--loaderCommon" style={{ marginBottom: '20px' }}></div>
                                <p style={{ color: '#666', margin: 0 }}>Loading bundle options...</p>
                            </div>
                        ) : bundleData?.error ? (
                            <div className="hw-ndc-bundle-error" style={{
                                textAlign: 'center',
                                padding: '40px 20px',
                                color: '#dc3545'
                            }}>
                                <p>{bundleData.error}</p>
                                <button
                                    className="hw-btn hw-btn--secondary hw-btn--mdSize"
                                    onClick={() => {
                                        setShowNDCPopup(false);
                                        setSelectedNDCFare(null);
                                        setSelectedBundle(null);
                                        setBundleData(null);
                                    }}
                                >
                                    Close
                                </button>
                            </div>
                        ) : (
                            <>
                                <div className="hw-ndc-bundle-description">
                                    <p>Please select a bundle option for your flight:</p>
                                </div>

                                {/* <div className="mt-3 hw-search--flightFilterResult__fareDetailsList" >
                                            <div className='d-flex mt-3'>
                                                <div className="hw-text20 hw-xstext16 hw-break--word hw-text--uppercase hw-black hw-fontBold flex-1">{selectedNDCFare?.pricingData?.fareIdentifier}</div>
                                                <div className="d-flex hw-gapy10 hw-gapy50--xxl align-items-start">
                                                    <span
                                                        className="hw-text20 hw-xstext16 hw-black hw-fontBold">{formatPrice(selectedNDCFare?.pricingData?.totalPrice, true)} {agentActiveCurrency}</span>
                                                    <button onClick={() => flightBookingFn(
                                                        selectedNDCFare.flights?.source,
                                                        selectedNDCFare.flights,
                                                        { id: selectedNDCFare.pricingData?.id },
                                                        selectedNDCFare.pricingData
                                                    )}
                                                        className="hw-btn hw-btn--mdSize hw-btn--secondary hw-btn--mn140">Book </button>
                                                </div>
                                            </div>
                                        </div> */}

                                {bundleData && bundleData.length > 0 ? (
                                    bundleData.map((bundle, index) => (
                                        <div className="hw-search--flightFilterResult__fareDetailsList">
                                            <div className="d-flex">
                                                <div className="hw-text20 hw-xstext16 hw-break--word hw-text--uppercase hw-black hw-fontBold flex-1">{bundle?.fareIdentifier}</div>
                                                <div className="d-flex hw-gapy10 hw-gapy50--xxl align-items-start">
                                                    <span
                                                        className="hw-text20 hw-xstext16 hw-black hw-fontBold">{formatePriceFn(agentActiveCurrency, formatPrice((bundle?.totalPrice + selectedNDCFare?.pricingData?.totalPrice), false, true), displayPrice)}</span>
                                                    <button onClick={() => handleBundleSelection(bundle)}
                                                        className="hw-btn hw-btn--mdSize hw-btn--secondary hw-btn--mn140">Book </button>
                                                </div>
                                            </div>
                                            <div className="hw-fare--listPoint">
                                                {bundle?.includedServices[1] && (
                                                    <div className="d-flex hw-gapy10 hw-fare--listPointItem">
                                                        <span className="hw-gapy8 d-flex flex-shrink--null"><LuggageIcon />Check-in baggage:</span>
                                                        <div>{bundle?.includedServices[1]}</div>
                                                    </div>
                                                )}
                                                {bundle?.includedServices[0] && (
                                                    <div className="d-flex hw-gapy10 hw-fare--listPointItem">
                                                        <span className="hw-gapy8 d-flex flex-shrink--null"><CabinIcon />Cabin baggage:</span>
                                                        <div>{bundle?.includedServices[0]}</div>
                                                    </div>
                                                )}

                                                {
                                                    bundle?.includedServices?.[2] !== 'No meal' && <div className="d-flex hw-gapy10 hw-fare--listPointItem">
                                                        <span className="hw-gapy8 d-flex flex-shrink--null"><MealIcon />Meal:</span>
                                                        <div>{bundle?.includedServices[2] === 'No meal' ? 'Chargeable' : 'Non Chargeable'}</div>
                                                    </div>
                                                }
                                                <div className="d-flex hw-gapy10 hw-fare--listPointItem">
                                                    <span className="hw-gapy8 d-flex flex-shrink--null"><TicketIcon />{bundle?.includedServices[3]}</span>
                                                    <span className="hw-gapy8 d-flex flex-shrink--null"><TicketIcon />{bundle?.includedServices[4]}</span>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="hw-ndc-bundle-no-data" style={{
                                        textAlign: 'center',
                                        padding: '40px 20px',
                                        color: '#666'
                                    }}>
                                        <p>No bundle options available for this flight.</p>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                )}
            </CommonPopup>
            <div className={`hw-modal-backdrop fade ${openFareViews ? 'show' : ''}`} />
        </>
    )
}


const FareSkeletonBar = ({ w, h, r = '6px', mb = 0, flex }) => (
    <span
        style={{
            display: 'block',
            width: w,
            height: h,
            borderRadius: r,
            marginBottom: mb,
            flex: flex,
            backgroundColor: '#eceff4',
            animation: 'skeleton-pulse 1.5s ease-in-out infinite',
        }}
    />
);

const renderFareSkeletonSlides = () => (
    <>
        {[0, 1, 2, 3].map((i) => (
            <SwiperSlide key={`fare-skeleton-${i}`}>
                <div className='hw-fare--slideItem'>
                    <div className='hw-fare--slideBox'>
                        <div className='b-top'>
                            <div className='b-top--header-row'>
                                <FareSkeletonBar w='55%' h='2.4rem' mb='0.6rem' />
                                <FareSkeletonBar w='25%' h='1.8rem' r='4px' />
                            </div>
                            <FareSkeletonBar w='40%' h='1.4rem' />
                        </div>
                        <div className='b-middle'>
                            <div className='b-section'>
                                <FareSkeletonBar w='30%' h='1.4rem' mb='0.6rem' />
                                <div style={{ display: 'flex', alignItems: 'center', gap: '0.8rem', marginBottom: '0.6rem' }}>
                                    <FareSkeletonBar w='1.5rem' h='1.5rem' r='50%' flex='none' />
                                    <FareSkeletonBar w='65%' h='1.3rem' />
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '0.8rem' }}>
                                    <FareSkeletonBar w='1.5rem' h='1.5rem' r='50%' flex='none' />
                                    <FareSkeletonBar w='75%' h='1.3rem' />
                                </div>
                            </div>
                            <div className='b-section'>
                                <FareSkeletonBar w='30%' h='1.4rem' mb='0.6rem' />
                                <div style={{ display: 'flex', alignItems: 'center', gap: '0.8rem', marginBottom: '0.6rem' }}>
                                    <FareSkeletonBar w='1.5rem' h='1.5rem' r='50%' flex='none' />
                                    <FareSkeletonBar w='80%' h='1.3rem' />
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '0.8rem' }}>
                                    <FareSkeletonBar w='1.5rem' h='1.5rem' r='50%' flex='none' />
                                    <FareSkeletonBar w='70%' h='1.3rem' />
                                </div>
                            </div>
                            <div className='b-section'>
                                <FareSkeletonBar w='40%' h='1.4rem' mb='0.6rem' />
                                <div style={{ display: 'flex', alignItems: 'center', gap: '0.8rem' }}>
                                    <FareSkeletonBar w='1.5rem' h='1.5rem' r='50%' flex='none' />
                                    <FareSkeletonBar w='60%' h='1.3rem' />
                                </div>
                            </div>
                        </div>
                        <div className='b-footer'>
                            <FareSkeletonBar w='100%' h='4.4rem' r='6px' />
                        </div>
                    </div>
                </div>
            </SwiperSlide>
        ))}
    </>
);


const FareViewsHtmlComponent = ({
    fareIdentifier,
    totalPrice,
    agentActiveCurrency,
    onClickFn,
    CheckInBagagge,
    cabbinBaggage,
    mealIndicator,
    fareRuleCancellationAmount,
    description,
    vendor,
    roundTripDomestic,
    selectMultiFlightFn,
    activeFlightOption,
    priceId,
    haveBundles = false,
    showBundles,
    setBundle,
    type = "",
    isCompatible = true,
    bundleData,
    displayPrice,
    features = [],
    selectionId = null,
    selectedId = null,
    badge = null
}) => {
    // eslint-disable-next-line no-unused-vars
    const [showFlyDubaiCompatibility, setShowFlyDubaiCompatibility] = useState(false);

    const isFareSelected = selectionId != null
        ? selectionId === selectedId
        : activeFlightOption?.priceId?.id === priceId;

    let badgeText = badge;
    if (!badgeText) {
        if (haveBundles) {
            badgeText = "BUNDLE";
        } else if (fareIdentifier && String(fareIdentifier).toLowerCase().includes("special")) {
            badgeText = "GO SPECIAL";
        }
    }

    return (
        <div className={`hw-fare--slideItem ${isFareSelected ? 'is-selected' : ''}`}>
            <div className='hw-fare--slideBox'>
                <div className='b-top'>
                    <div className='b-top--header-row'>
                        <div className='d-flex align-items-baseline'>
                            <span className='hw-price-amount'>
                                {formatePriceFn(
                                    agentActiveCurrency,
                                    formatPrice(
                                        getEffectiveTotalPriceFn(
                                            haveBundles
                                                ? { ...(bundleData || {}), bundle: true, totalPrice }
                                                : { totalPrice }
                                        ),
                                        false,
                                        true
                                    ),
                                    displayPrice
                                )}
                            </span>
                        </div>
                        {badgeText && (
                            <span className='hw-fare-card-badge'>{badgeText}</span>
                        )}
                    </div>
                    <div className='hw-fare-identifier'>{fareIdentifier || 'STANDARD'}</div>
                </div>

                <div className='b-middle'>
                    {/* Baggage Section */}
                    <div className='b-section'>
                        <div className='b-mmiddle--title'>Baggage</div>
                        <div className='b-mmiddle--list'>
                            <span className='hw-fare-icon-green'><FareCheckIcon /></span>
                            <span>{cabbinBaggage || '7 Kgs'} Cabin Baggage</span>
                        </div>
                        <div className='b-mmiddle--list'>
                            {CheckInBagagge && CheckInBagagge !== 'N/A' && CheckInBagagge !== '0' && CheckInBagagge !== '0 Kg' && CheckInBagagge !== 'Chargable' ? (
                                <>
                                    <span className='hw-fare-icon-green'><FareCheckIcon /></span>
                                    <span>{CheckInBagagge} Check-in Baggage</span>
                                </>
                            ) : CheckInBagagge === 'Chargable' ? (
                                <>
                                    <span className='hw-fare-icon-amber'><FareMinusIcon /></span>
                                    <span>Chargeable Check-in Baggage</span>
                                </>
                            ) : (
                                <>
                                    <span className='hw-fare-icon-amber'><FareMinusIcon /></span>
                                    <span>Check-in Baggage policy applies</span>
                                </>
                            )}
                        </div>
                    </div>

                    {/* Seats, Meals & More Section */}
                    <div className='b-section'>
                        {(vendor === 'ndc-portal' && mealIndicator) && (
                            <>
                                <span className='b-mmiddle--title hw-blue hw-fontBold'>Seats, Meals & More</span>
                                <div className='b-mmiddle--list'><MealIcon />{mealIndicator}</div>
                            </>
                        )}
                        {(vendor !== 'travel-fusion' && vendor !== 'akasa-air' && vendor !== 'air-arabia' && vendor !== 'ndc-portal' && mealIndicator) && (
                        <>
                            <span className='b-mmiddle--title hw-blue hw-fontBold'>Seats, Meals & More</span>
                            <div className='b-mmiddle--list'><MealIcon />{mealIndicator ? 'Chargeable' : 'Non Chargeable'} Meal</div>
                        </>
                    )}
                    </div>

                    {/* Additional Features / Bundle Inclusions */}
                    {Array.isArray(features) && features.length > 0 && (
                        <div className='b-section'>
                            {features.map((feat, idx) => (
                                <div className='b-mmiddle--list' key={idx}>
                                    <span className='hw-fare-icon-green'><FareCheckIcon /></span>
                                    <span>{feat}</span>
                                </div>
                            ))}
                        </div>
                    )}

                    {/* Description lines */}
                    {description && (
                        <div className='b-section'>
                            {description.split('\n').filter(Boolean).map((line, idx) => (
                                <div className='b-mmiddle--list' key={idx}>
                                    <span className='hw-fare-icon-green'><FareCheckIcon /></span>
                                    <span>{line}</span>
                                </div>
                            ))}
                        </div>
                    )}

                    {/* NDC / Special Bundle Highlight */}
                    {/* {haveBundles && (
                        <div className='b-bundle-box'>
                            <span>⭐</span>
                            <span>Includes Special Bundle Privileges</span>
                        </div>
                    )} */}
                </div>

                <div className='b-footer'>
                    {(roundTripDomestic?.status && roundTripDomestic?.active === 1) ? (
                        <button
                            onClick={selectMultiFlightFn}
                            type="button"
                            className={`hw-btn ${isFareSelected ? 'hw-btn--selected-fare' : 'hw-btn--book-now'} w-100`}
                        >
                            {isFareSelected ? (
                                <>
                                    <SelectedFlightIcon />
                                    <span>SELECTED</span>
                                </>
                            ) : 'SELECT'}
                        </button>
                    ) : (
                        <button
                            onClick={onClickFn}
                            type="button"
                            className='hw-btn hw-btn--primary w-100' style={{fontSize : "14px"}}
                        >
                            BOOK NOW
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

const ErrorFaresComponent = () => {
    return (
        <span style={{ color: "red", display: "flex", justifyContent: "center", marginTop: "1.8rem", fontSize: "larger" }}>An error occurred while processing the request. Please contact support.</span>
    )
}

export default FareViewsComponent;
